import React, { useEffect, useState } from "react";
import Section_title from "../../../common-components/section-title/Section_title";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import {
  GetSingle,
  Update,
  Create,
} from "../../../../features/admin/form/contactus/Slice";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import Add from "./Add";
import Pagination_Holder from "../../../common-components/Pagination_Holder/Pagination_Holder";
import Table_search from "../../../common-components/table-search/Table_search";
import { Button } from "react-bootstrap";
import View_Modal from "../../../common-components/common_Modal/view_Modal/View_Modal";
import { formatDate } from "../../../../utils/common";
import { DOWNLOAD_EXCEL } from "../../../../utils/Methods";
import { GetAllWalletHistory } from "../../../../features/admin/customer_wallet/wallet_history/slice";
import Successfull_Modal from "../../../common-components/common_Modal/Successfull_Modal/Successfull_Modal";

const Booking = () => {
  const dispatch = useDispatch();
  const [modalShow, setModalShow] = useState(false);
  const [showSuccessfull, setShowSuccessful] = useState(false);
  const [dropdetails, setDropDetails] = useState("");

  const {
    country,
    first_name,
    setName,
    email,
    setemail,
    contact_no,
    setcontact_no,
    from,
    setFrom,
    to,
    setTo,
    fetch,
    deleteData,
    toggleStatus,
  } = IndexUse();

  const [selectAllChecked, setSelectAllChecked] = useState([]);
  const [allChecked, setAllChecked] = useState([]);
  useEffect(() => {
    if (country?.data?.data) {
      const newIds = country?.data?.data?.map((d) => d.id);
      setAllChecked(newIds);
    }
  }, [country?.data]);

  const [add, setAdd] = useState(false);
  const [edit, setEdit] = useState(false);
  const [rdelete, setRDelete] = useState(false);
  const [success, setSuccess] = useState(false);
  const [err, setErr] = useState(false);

  const [id, setId] = useState("");

  const handlePageChange = async (page) => {
    await fetch(page);
  };

  const handleSelectAll = async () => {
    await setSelectAllChecked(allChecked);
  };

  const handleChange = async (e) => {
    const { value, checked } = e.target;

    if (value === "selectAll") {
      if (checked) {
        handleSelectAll();
      } else {
        await setSelectAllChecked([]);
      }
    } else {
      if (checked) {
        await setSelectAllChecked([...selectAllChecked, Number(value)]);
      } else {
        await setSelectAllChecked(
          selectAllChecked.filter((e) => e !== Number(value))
        );
      }
    }
  };

  const HandleDownload = async () => {
    // if (selectAllChecked.length == 0) {
    //   alert("Please Select Atleast One Record");
    // } else {
      try {
        await DOWNLOAD_EXCEL(
          "/admin/wallet/wallet-history/download",
          selectAllChecked,
          "Wallet History List"
        );
      } catch (error) {
        console.error("Error:", error);
      }
    // }
  };

  return (
    <>
      <section className="content_body section_box">
        <div className="top_title_sec">
          <div className="forms_section">
            <div className="row align-items-end">
              <div className="col-md-12">
                <Section_title title="Customer Wallet History" alltotal="" />
              </div>
              <div className="col-md-4 mb-3 form-group">
                <label className="form-label">Filter by First Name</label>
                <Form.Control
                  type="text"
                  placeholder="Enter First Name"
                  value={first_name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="col-md-4 mb-3 form-group">
                <label className="form-label">Filter by Email</label>
                <Form.Control
                  type="text"
                  placeholder="Enter Email"
                  value={email}
                  onChange={(e) => setemail(e.target.value)}
                />
              </div>
              <div className="col-md-4 mb-3 form-group">
                <label className="form-label">Filter by Contact Number</label>
                <Form.Control
                  type="text"
                  placeholder="Enter Contact Number"
                  value={contact_no}
                  onChange={(e) => setcontact_no(e.target.value)}
                />
              </div>
              <div className="col-md-4 mb-3 form-group">
                <label className="form-label">Filter by From</label>
                <Form.Control
                  type="date"
                  placeholder="Enter From"
                  value={from}
                  onChange={(e) => {
                    setFrom(e.target.value);
                    handlePageChange(1);
                    setTo("");
                  }}
                />
              </div>
              <div className="col-md-4 mb-3 form-group">
                <label className="form-label">Filter by To</label>
                <Form.Control
                  type="date"
                  placeholder="Enter To"
                  value={to}
                  onChange={(e) => {
                    setTo(e.target.value);
                    handlePageChange(1);
                  }}
                  min={from}
                />
              </div>
              <div className="col-md-4 mb-3" style={{ width: "fit-content" }}>
                <button
                  className="btn btn-danger "
                  onClick={() => {
                    setName("");
                    setemail("");
                    setcontact_no("");
                    setFrom("");
                    setTo("");
                  }}
                >
                  Reset
                </button>
              </div>
              <div className="mb-3">
                {/* <CButton name="Reset" variant="danger" action={handleReset} /> */}
                {/* <CButton name="Add" variant="success" action={() => setAdd(true)} /> */}
                <button className="btn btn-success " onClick={HandleDownload}>
                  Download Excel
                </button>
              </div>{" "}
            </div>
          </div>
        </div>

        {/* <Add id={id} setId={setId} /> */}

        <div className="table_section theme_bg">
          <div className="table-responsive">
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  {/* <th>
                    <input
                      type="checkbox"
                      value="selectAll"
                      checked={allChecked.length === selectAllChecked.length}
                      onChange={handleChange}
                      id="selectAll"
                      className="me-1"
                    ></input>
                    Select
                  </th> */}
                  <th>S. no.</th>
                  <th>Customer First Name</th>
                  {/* <th>Customer Email</th> */}
                  <th>Customer Contact No</th>
                  <th>Transaction type</th>
                  <th>Amount</th>
                  <th>Account Number</th>
                  <th>Ifsc Code</th>
                  <th>UPI Id</th>
                  <th>Date</th>

                  <th>Remark</th>
                </tr>
              </thead>
              <tbody>
                {country?.data?.data?.length > 0 ? (
                  country?.data.data?.map((val, index) => (
                    <tr key={index}>
                      {/* <td>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          value={val?.id}
                          name="perselected"
                          checked={selectAllChecked.includes(val?.id)}
                          onChange={handleChange}
                          id="flexCheckDefault"
                        />
                      </td>{" "} */}
                      <td>
                        {(country?.data?.current_page - 1) *
                          country?.data?.per_page +
                          index +
                          1}
                      </td>
                      <td>{val?.User?.first_name || "-"}</td>
                      {/* <td>{val?.User?.email || "-"}</td> */}
                      <td>{val?.User?.contact_no || "-"}</td>
                      <td>{val?.transaction_type || "-"}</td>
                      <td>₹ {val?.amount || "-"}</td>
                      <td> {val?.WithdrawRequest?.account_no || "-"}</td>
                      <td> {val?.WithdrawRequest?.ifsc_code || "-"}</td>
                      <td> {val?.WithdrawRequest?.upi_id || "-"}</td>
                      <td>
                        {new Date(val?.createdAt).toLocaleString("en-IN", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })}
                      </td>
                      <td> {val?.remark || "-"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center">
                      No Data
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <Pagination_Holder
          onPageChange={country?.data?.current_page}
          totalPages={country?.data?.total_pages}
          handlePageChange={handlePageChange}
        />
      </section>

      <View_Modal
        show={modalShow}
        dropdetails={dropdetails}
        onHide={() => setModalShow(false)}
      />

      <Successfull_Modal
        message={"Status Successful"}
        show={showSuccessfull}
        onHide={() => setShowSuccessful(false)}
      />
    </>
  );
};

export default Booking;
